/**
 * Copyright (C) 2013-2021 MNEMOTIX <http://www.mnemotix.com/> and/or its affiliates
 * and other contributors as indicated by the @author tags.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import {gql} from "@apollo/client";
import {gqlConceptFragment} from "./Concept.gql";

export const gqlConceptPropertiesFragment = gql`
  fragment ConceptPropertiesFragment on Concept {
    ...ConceptFragment
    prefLabelTranslations {
      value
      lang
    }
    altLabelTranslations {
      value
      lang
    }
    definitionTranslations {
      value
      lang
    }
    hiddenLabelTranslations {
      value
      lang
    }
    scopeNoteTranslations{
      value
      lang
    }
    changeNoteTranslations{
      value
      lang
    }
    notationTranslations{
      value
      lang
    }
    noteTranslations{
      value
      lang
    }
    historyNoteTranslations{
      value
      lang
    }
    exampleTranslations{
      value
      lang
    }
    editorialNoteTranslations{
      value
      lang
    }
    taggings{
      totalCount
      edges {
        node{id}
      }
    }
  }

  ${gqlConceptFragment}
`;

export const gqlConceptProperties = gql`
  query ConceptProperties($id: ID!) {
    concept(id: $id) {
      ...ConceptPropertiesFragment
    }
  }

  ${gqlConceptPropertiesFragment}
`;
